import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ITheadSort, ListLayout } from '../../../../../../../global/tables/table-list-layout';
import { TGetMeetingsSortKeys } from '../../../../../../../../api/control.dao';
import TableLoadingRow from '../../../../../../../global/tables/table-loading-row';
import { Paging } from '../../../../../../../global/_paging/paging-container';
import { PagingViewModel } from '../../../../../../../global/_paging/paging-viewmodels/regular-paging.viewmodel';
import { ScheduledMeetingEventListItem } from './_meeting-list-item';
import { observer } from 'mobx-react';
import { SortOrder } from '../../../../../../../../api/shared.dto';
import { EMPTY_LIST_TEXT, MEETING_TYPE_TEXT, PRESENTERS_TEXT, TRACK_TEXT } from './_meeting-list.texts';
import { DATE_AND_TIME_TEXT, TOPIC_TEXT } from '../../../../../../../../constants/common-labels.constants';
import { IMeetingDetailsDTO } from '../../../../../../../../api/meetings.dao';
import { IDateTimeFormatter } from '../../../../../../../../infrastructure/date-formatter';

interface IProps {
    loading: boolean;
    meetings: IMeetingDetailsDTO[];
    selectedMeetingId: number;
    setMeetingId: (value: number) => void;
    pagingVM: PagingViewModel;
    setSortParams: (field: TGetMeetingsSortKeys, order: SortOrder) => void;
    sortOrder: SortOrder;
    sortField: TGetMeetingsSortKeys;
    timezone: string;
    dateTimeFormatter: IDateTimeFormatter;
}

const ScheduledMeetingEmailsMeetingsList = observer(({
    meetings, loading, selectedMeetingId, pagingVM, setMeetingId,
    setSortParams, sortOrder, sortField, timezone, dateTimeFormatter
}: IProps) => {
    const intl = useIntl();
    const isEmptyList = !meetings || !meetings.length;
    const theads: ITheadSort<Extract<'startDateTime', TGetMeetingsSortKeys>>[] = [
        {
            width: '3%'
        },
        {
            title: intl.formatMessage(DATE_AND_TIME_TEXT),
            sortField: 'startDateTime',
            width: '30%'
        },

        {
            title: intl.formatMessage(TOPIC_TEXT),
            width: '15%'
        },
        {
            title: intl.formatMessage(PRESENTERS_TEXT),
            width: '10%'
        },
        {
            title: intl.formatMessage(MEETING_TYPE_TEXT),
            width: '10%'
        },
        {
            title: intl.formatMessage(TRACK_TEXT),
            width: '10%'
        }
    ];

    return (
        <section className='fixed-list-layout'>
            <div>
                <ListLayout
                    sortOptions={{
                        theads: theads,
                        sortRows: setSortParams,
                        sortOrder: sortOrder,
                        sortField: sortField
                    }}
                    isDisabled={isEmptyList}
                >
                    {loading && <TableLoadingRow colSpan={theads.length} />}
                    {!isEmptyList && !loading && meetings.map((meeting: IMeetingDetailsDTO) => {
                        return <ScheduledMeetingEventListItem
                            item={meeting}
                            key={meeting.meetingId}
                            isSelected={meeting.meetingId === selectedMeetingId}
                            setMeetingId={setMeetingId}
                            timezone={timezone}
                            dateTimeFormatter={dateTimeFormatter}
                        />;
                    })
                    }
                </ListLayout>
                {isEmptyList &&
                    <div className='empty-list-message'>
                        <FormattedMessage {...EMPTY_LIST_TEXT} />
                    </div>
                }
            </div>
            <Paging pagingVM={pagingVM} />
        </section>
    );
});

export { ScheduledMeetingEmailsMeetingsList };